<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <div class="card-body pb-0">
          <div *ngIf="!!product" class="row">
            <div class="col-12 mb-1" id="customer-profile">
              <h3 class="mb-0">{{ product.name }}</h3>
            </div>
            <div class="col-12 mb-1">
              <div class="row">
                <div class="col mb-md-1">
                  <div class="font-weight-bold font-medium-1">{{ "PRICE" | translate }}:</div>
                  <div>{{ _utilService.addDotsToNumber(product.monthly_amount) }}</div>
                </div>
                <div class="col mb-lg-1">
                  <div class="font-weight-bold font-medium-1">{{ "PRESUMED_TOTAL_MONTHLY_COST" | translate }}:</div>
                  <div>{{ _utilService.addDotsToNumber(product.monthly_cost) }}</div>
                </div>
              </div>
              <div class="row">
                <div class="col mb-md-1">
                  <div class="font-weight-bold font-medium-1">{{ "DESCRIPTION" | translate }}:</div>
                  <div>{{ product.description }}</div>
                </div>
                <div class="col mb-lg-1">
                  <div *ngIf="product.attachments && product.attachments.length > 0" class="font-weight-bold font-medium-1">
                    {{ "ATTACHMENTS" | translate }}:
                    <ul class="list-unstyled">
                      <li class="text-primary cursor-pointer" *ngFor="let attachment of product.attachments" (click)="_utilService.getFile(attachment.url)">
                        {{ attachment.filename }}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-title pt-2 px-2">
          <h3>{{ "MENU.DEALS" | translate }}</h3>
          <div class="row pt-1" *ngIf="!!dealsList && dealsList.length > 0">
            <div class="col-lg-4">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKeyDeals" (ngModelChange)="searchDeal()" />
            </div>
            <div class="col-lg-8 d-flex justify-content-end" *ngIf="!_utilService.isMobile">
              <label class="d-flex w-fit align-items-center" for="page_quantity"
                >{{ "SHOW" | translate }}
                <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)" id="page_quantity">
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </label>
            </div>
          </div>
        </div>
        <div class="card-body p-0" *ngIf="!!dealsList && dealsList.length > 0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 180"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterDeals"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'complete_name', dir: 'desc' }]"
          >
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="_utilService.isDesktop" [width]="410">
              <ng-template ngx-datatable-cell-template let-row="row">
                <p *ngIf="!_authenticationService.hasCapability('edit_deal')">{{ row.complete_name }}</p>
                <a href="dashboard/deals/edit-product-deal/{{ row.id }}" class="text-break-line-2" *ngIf="_authenticationService.hasCapability('edit_deal')">{{ row.complete_name }}</a>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [name]="'CUSTOMER_COMMERCIAL' | translate" prop="commercial.complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>{{ row.commercial?.complete_name }}</div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [name]="'PRODUCTS' | translate" prop="description" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div [ngbTooltip]="descriptionTooltip(row.description)" placement="top-left" [ngStyle]="{ width: '150px' }">
                  <i [data-feather]="'package'" size="19"></i>
                </div>
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column [name]="'DEAL_ORDER' | translate" prop="commission.name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a target="_blank" routerLink="/dashboard/commissions/edit-product-commission/{{ row.commission.id }}" *ngIf="!!row.commission && !!row.commission.name">{{ row.commission.name }}</a>
                <span *ngIf="!row.commission || !row.commission.name">-</span>
              </ng-template>
            </ngx-datatable-column>

            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <a href="dashboard/deals/edit-product-deal/{{ row.id }}" class="text-break-line-2">{{ row.complete_name }}</a>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "CUSTOMER_COMMERCIAL" | translate }}: </span>
                    <span>{{ row.commercial?.complete_name }}</span>
                  </div>
                  <div class="col-12">
                    <span class="font-weight-bold">{{ "DEAL_ORDER" | translate }}: </span>
                    <a target="_blank" routerLink="/dashboard/commissions/edit-product-commission/{{ row.commission.id }}" *ngIf="!!row.commission && !!row.commission.name">{{ row.commission.name }}</a>
                    <span *ngIf="!row.commission || !row.commission.name">-</span>
                  </div>
                  <div class="col-12">
                    <span *ngIf="!!row.description && row.description.length > 0" ngbDropdown data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="d-flex align-items-center w-100 dropup">
                      <i [data-feather]="'package'" size="19"></i>
                      <div class="w-100" id="dropdownMenuButton2" ngbDropdownToggle>
                        <span class="ml-1">{{ "MENU.PRODUCTS" | translate }}</span>
                      </div>
                      <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton2">
                        <button class="dropdown-item" *ngFor="let product of row.description">
                          {{ product }}
                        </button>
                      </div>
                    </span>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        <div class="card-body px-2 pt-1" *ngIf="!dealsList || dealsList.length === 0">
          <p>{{ "ALERT.NO_DEALS" | translate }}</p>
        </div>
      </div>
      <div class="card">
        <div class="card-title pt-2 px-2">
          <h3 class="mb-0">{{ "DEAL_ORDERS" | translate }}</h3>
          <div class="row pt-1" *ngIf="!!commissionList && commissionList.length > 0">
            <div class="col-lg-4">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKeyCommission" (ngModelChange)="searchDealOrder()" />
            </div>
            <div class="col-lg-8 d-flex justify-content-end" *ngIf="!_utilService.isMobile">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.md]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'">
                <label class="d-flex align-items-center"
                  >{{ "SHOW" | translate }}
                  <select class="form-control ml-075 pr-3" (change)="updateTableLimit($event)">
                    <option value="10">10</option>
                    <option value="25">25</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body px-0 pt-0" *ngIf="!!commissionList && commissionList.length > 0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 180"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filterCommission"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [sorts]="[{ prop: 'complete_name', dir: 'desc' }]"
          >
            <ngx-datatable-column [name]="'NAME' | translate" prop="complete_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a target="_blank" routerLink="/dashboard/commissions/edit-product-commission/{{ row.id }}" *ngIf="!!row.complete_name">{{ row.complete_name }}</a>
                <span *ngIf="!row.complete_name">-</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PRODUCTS' | translate" *ngIf="_utilService.isDesktop" [sortable]="false">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span [ngbTooltip]="descriptionTooltip(row.products_names)" placement="top-left" [ngStyle]="{ width: '150px' }">
                  <i [data-feather]="'package'" size="19"></i>
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_COSTS' | translate" prop="general_analytics.general_real_cost" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <span>{{ _utilService.addDotsToNumber(row.general_analytics && row.general_analytics.general_real_cost ? row.general_analytics.general_real_cost : 0) }} €</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TOTAL_REVENUE' | translate" prop="general_analytics.general_real_profit" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <span>{{ _utilService.addDotsToNumber(row.general_analytics && row.general_analytics.general_real_profit ? row.general_analytics.general_real_profit : 0) }} €</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'PERCENTAGE_MARGIN' | translate" prop="general_analytics.general_margin_percentage" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <span>{{ row.general_analytics && row.general_analytics.general_margin_percentage ? row.general_analytics.general_margin_percentage : "-" }} %</span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EURO_MARGIN' | translate" prop="general_analytics.general_margin_currency" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  {{ row.general_analytics && row.general_analytics.general_margin_currency ? _utilService.addDotsToNumber(row.general_analytics.general_margin_currency) : "-" }}
                  €
                </div>
              </ng-template>
            </ngx-datatable-column>

            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'NAME' | translate" prop="name" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-12">
                    <a target="_blank" routerLink="/dashboard/commissions/edit-product-commission/{{ row.id }}" *ngIf="!!row.complete_name">{{ row.complete_name }}</a>
                    <span *ngIf="!row.complete_name">-</span>
                  </div>
                  <div class="col-12">
                    <span *ngIf="!!row.description && row.description.length > 0" ngbDropdown data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="d-flex align-items-center w-100 dropup">
                      <i [data-feather]="'package'" size="19"></i>
                      <div class="w-100" id="dropdownMenuButton2" ngbDropdownToggle>
                        <span class="ml-1">{{ "MENU.PRODUCTS" | translate }}</span>
                      </div>
                      <div class="dropdown-menu w-100" aria-labelledby="dropdownMenuButton2">
                        <button class="dropdown-item" *ngFor="let product of row.products_names">
                          {{ product }}
                        </button>
                      </div>
                    </span>
                  </div>
                </div>
                <div>
                  <span>{{ "TOTAL_COSTS" | translate }}: </span>
                  <span>{{ _utilService.addDotsToNumber(row.general_analytics && row.general_analytics.general_real_cost ? row.general_analytics.general_real_cost : 0) }} €</span>
                </div>
                <div>
                  <span>{{ "TOTAL_REVENUE" | translate }}: </span>
                  <span>{{ _utilService.addDotsToNumber(row.general_analytics && row.general_analytics.general_real_profit ? row.general_analytics.general_real_profit : 0) }} €</span>
                </div>
                <div>
                  <span>{{ "PERCENTAGE_MARGIN" | translate }}: </span>
                  <span>{{ row.general_analytics && row.general_analytics.general_margin_percentage ? row.general_analytics.general_margin_percentage : "-" }} %</span>
                </div>
                <div>
                  <span>{{ "EURO_MARGIN" | translate }}: </span>
                  <span>{{ row.general_analytics && row.general_analytics.general_margin_currency ? _utilService.addDotsToNumber(row.general_analytics.general_margin_currency) : "-" }} €</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
        <div class="card-body px-2 pt-1" *ngIf="!commissionList || commissionList.length === 0">
          <p>{{ "ALERT.NO_COMMISSIONS" | translate }}</p>
        </div>
      </div>
    </section>
  </div>
</div>
